module.exports = __webpack_public_path__ + "img/ch56.b80c38a1.jpg";